import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { IconWarningFill } from '@saucelabs/ds-icons';

const RegressionAlert = ({ regressionData, getPerformanceURL }) => (
  <div className={classNames('label', 'w-full')}>
    <div className="flex gap-x-1 text-orange-600 normal-case">
      <IconWarningFill className="text-orange-600 text-current w-2 h-2" />
      We&apos;ve found a baseline regression in the performance data for
      {' '}
      <Link to={getPerformanceURL({ orderIndex: regressionData.order_index }).reportPageURL}>
        this URL
      </Link>
    </div>
  </div>
);

RegressionAlert.propTypes = {
  getPerformanceURL: PropTypes.func.isRequired,
  regressionData: PropTypes.object.isRequired,
};

export default RegressionAlert;
